module.exports = "<fw-page-header-bar [config]=\"pageHeaderBarConfig\" (btnClick)=\"btnHeaderBarClicked($event)\"></fw-page-header-bar>\r\n\r\n<fw-dynamic-form\r\n                 [vmDefinition]=\"config.filterDefinition\"\r\n                 [operation]=\"operation\"\r\n                 [errorMessage]=\"errorMessage\">\r\n</fw-dynamic-form>\r\n\r\n<fw-page-subheader-bar [config]=\"config.pageSubheaderBarConfig\" (btnClick)=\"btnSubHeaderBarClicked($event)\"></fw-page-subheader-bar>\r\n\r\n<fw-dynamic-grid [vmColumnDefinition]=\"config.columnDefinition\"></fw-dynamic-grid>";


//////////////////
// WEBPACK FOOTER
// ./Scripts/fw/pages/page-searchable-list.component.html
// module id = 2272
// module chunks = 1